// extracted by mini-css-extract-plugin
module.exports = {"risks-documents-form__title":"kofjSuXU3-7DAcolbSuXM"};